module.exports = __webpack_public_path__ + "media/images/favicons/favicon-ba6e13795415be06090d788c4b22a7b5.ico";